import React, { ComponentProps, PropsWithChildren, useRef } from 'react'
import { StickyContainer } from 'react-sticky'

import { bemJoin } from 'bem-join'
import classnames from 'classnames'

import './Page.scss'

export type PageProps = ComponentProps<'div'>

const b = bemJoin('lawyer-page')

export const Page = ({ children, className, ...rest }: PropsWithChildren<PageProps>) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <StickyContainer>
      <div className={classnames(b(), className)} ref={ref} {...rest}>
        {children}
      </div>
    </StickyContainer>
  )
}
